import axiosRequest from "api";
import { payloadHelper } from "helpers/payload-helper";
import { ApiResponse } from "types/api";

import {
  TransferPointFormPayload,
  TransferPointFormResponse,
  TransferPointHistoryPayload,
  TransferPointHistoryResponse,
  TransferPointPayload,
  WalletTransferPayload,
} from "./type";

export const TransferApi = {
  walletTransfer: async (typename: string, payload: WalletTransferPayload) => {
    const res = await axiosRequest.post<ApiResponse>(
      "",
      payloadHelper("WalletTransfer", typename, payload)
    );
    return res.data;
  },
  transferPointForm: async (
    typename: string,
    payload: TransferPointFormPayload
  ) => {
    const res = await axiosRequest.post<TransferPointFormResponse>(
      "",
      payloadHelper("TransferPointForm", typename, payload)
    );
    return res.data;
  },
  transferPoint: async (typename: string, payload: TransferPointPayload) => {
    const res = await axiosRequest.post<ApiResponse>(
      "",
      payloadHelper("TransferPoint", typename, payload)
    );
    return res.data;
  },
  transferPointHistory: async (
    typename: string,
    payload: TransferPointHistoryPayload
  ) => {
    const res = await axiosRequest.post<TransferPointHistoryResponse>(
      "",
      payloadHelper("TransferPointHistory", typename, payload)
    );
    return res.data;
  },
};
